export default "__VITE_ASSET__BQ15I6KF__"